import { useState } from 'react';
import { toast } from 'sonner';
import { fetchWithAuth } from '../../utils/api';
import { buildInvestmentSubmitData } from '../investmentFormUtils';
import logger from '../../utils/logger';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const useInvestmentSubmit = (investment, onSuccess) => {
  const [isLoading, setIsLoading] = useState(false);
  const isEditing = !!investment;

  const handleSubmit = async (e, formData) => {
    e.preventDefault();
    if (!formData.name || !formData.type || !formData.amount) {
      toast.error('Please complete all required fields marked *');
      return;
    }
    setIsLoading(true);
    try {
      const submitData = buildInvestmentSubmitData(formData, isEditing);
      const url = isEditing
        ? `${BACKEND_URL}/api/investments/${investment.investment_id}`
        : `${BACKEND_URL}/api/investments`;
      const response = await fetchWithAuth(url, {
        method: isEditing ? 'PUT' : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(submitData),
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || `${isEditing ? 'Update' : 'Create'} failed`);
      }
      toast.success(`Investment ${isEditing ? 'updated' : 'created'} successfully!`);
      onSuccess();
    } catch (error) {
      logger.error('Investment operation error:', error);
      toast.error(error.message || `Failed to ${isEditing ? 'update' : 'create'} investment`);
    } finally {
      setIsLoading(false);
    }
  };

  const getSubmitLabel = () => {
    if (isLoading) return 'Saving...';
    return isEditing ? 'Update Investment' : 'Add Investment';
  };

  return { isLoading, isEditing, handleSubmit, getSubmitLabel };
};
